export default __webpack_public_path__ + "static/vg-145f8b770cfdcae9dff379a2f104999b.svg";